import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-[#0D0618] py-12 text-center" data-id="element-95">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#A855F7]/50 to-transparent" data-id="element-96" />

      <div className="mx-auto mt-12 max-w-[720px] px-5" data-id="element-97">
        <h4 className="font-heading text-lg font-bold text-violet-gradient sm:text-xl" data-id="element-98">
          🌿 KIT HIJOS EN CALMA™ 2026
        </h4>
        <p className="mt-2 text-sm text-[#9B8EC4] sm:text-base" data-id="element-99">
          Sistema de Control de Ansiedad Infantil
        </p>

        <div className="my-8 flex flex-wrap justify-center gap-4 text-sm text-[#9B8EC4]" data-id="element-100">
          <span data-id="element-101">soportenexorecursos@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-102">•</span>
          <span data-id="element-103">@nexorecursoss</span>
        </div>

        <div className="flex flex-col gap-2 text-xs text-[#9B8EC4]" data-id="element-104">
          <p data-id="element-105">© Kit Hijos en Calma™ 2026 · Todos los derechos reservados.</p>
          <p data-id="element-106">
            Material educativo digital. No reemplaza diagnóstico médico
            profesional.
          </p>
        </div>
      </div>
    </footer>;
};